import React from 'react';

import StandardModal from '@/components/commons/StandardModal';
import Button, { ButtonSize, ButtonType } from '@/components/commons/button';

import styles from './ActionModal.module.css';

interface ConfirmActionModalTypes {
    readonly closeModal: () => void;
    readonly display: boolean;
    readonly onSubmit: () => void;
    readonly actionType: string;
    readonly modalType?: string;
    readonly element?: string;
}

const headers = {
    suspend: 'Are you sure you want to suspend your account?',
    unsuspend: 'Are you sure you want to reactivate your account?',
    delete: 'Are you sure you want to delete your account?',
};

const corpuses = {
    suspend: (
        <div>
            Suspending your account will cause Sixty to stop processing your email/calendars.  If
            you change your mind, you can reactivate your account from your Profile page at any
            time.
            <br />
            <br />
            If you simply want to pause processing for specific email accounts, you can do so from
            the Accounts page by un-checking the &quot;Enabled&quot; field on the desired accounts.
        </div>
    ),
    unsuspend: (
        <div>
            Reactivating your account will cause Sixty to resume processing your email/calendars on
            all accounts marked as enabled.
        </div>
    ),
    delete: (
        <div>
            Deleting your account will cause Sixty to immediately stop processing your
            email/calendars, and make it impossible for you to log in again.

            <br />
            <br />

            In 7 days, your data will be permanently deleted from our systems. If you change your
            mind within that period, you can email us at
            {' '}
            <a
                className="linkLike--secondary"
                href="mailto:support@sixty.inc"
            >
                support@sixty.inc
            </a>
            .
        </div>
    ),
};

function ConfirmActionModal({
    closeModal,
    display,
    onSubmit,
    actionType,
    modalType = '',
    element = '',
}: ConfirmActionModalTypes) {
    return (
        <StandardModal
            open={display}
            onClose={closeModal}
            data-testid="modal-confirmActionModal"
            headline="Confirm Your Action"
        >
            <div className="flex flex-col justify-center items-center">
                {modalType === 'agenda' ? (
                    <div className="flex flex-col justify-center items-center">
                        <h3 className={styles.modalHeader}>
                            Are you sure you want to remove this
                            {' '}
                            {element}
                            {' '}
                            ?
                        </h3>
                    </div>
                ) : (
                    <div className="flex flex-col justify-center items-center">
                        <h3 className={styles.modalHeader}>
                            {headers[actionType]}
                        </h3>

                        <p className="mt-4">
                            {corpuses[actionType]}
                        </p>
                    </div>
                )}

                <div className={styles.actionsContainer}>
                    <Button
                        size={ButtonSize.base}
                        externalStyles={styles.saveAction}
                        text="Yes, continue"
                        type={ButtonType.submit}
                        onClick={onSubmit}
                    />

                    <Button
                        size={ButtonSize.base}
                        externalStyles={styles.cancelAction}
                        text="Cancel"
                        type={ButtonType.secondary}
                        onClick={closeModal}
                    />
                </div>
            </div>
        </StandardModal>
    );
}

export default ConfirmActionModal;
